/**
 * 定义element ui表单规则 1
 */
let formRules = {
  requiredBlur: [{
    required: true,
    message: '该值不能为空',
    trigger: 'blur'
  }],
  requiredChange: [{
    required: true,
    message: '该值不能为空',
    trigger: 'change'
  }],
  userName: [{
    required: true,
    message: '请输入账号',
    trigger: 'change'
  }, ],
  userPassworm: [{
    required: true,
    message: '请输入密码',
    trigger: 'change'
  }, ],
  phoneNmuber: [{
      required: true,
      message: '该值不能为空',
      trigger: 'change'
    },
    {
      pattern: /^1[0-9]{10}$/,
      message: '输入正确的手机号码',
      trigger: 'blur'
    }
  ],
  userNameLength:[
    {
          required: true,
          message: '该值不能为空',
          trigger: 'change'
        }, {
      
          pattern: /^.{2,30}$/,
          message: '输入最小长度为2位，最大长度为30位'
        }
  ],
  not:{
    required:false
  },
    numberRequired: [{
      required: true,
      message: '该值不能为空',
      trigger: 'blur'
    },
    {
      type: "number",
      message: '输入数据类型错误，请输入数字！',
      trigger: 'blur'
    }
  ],

}
// let formRules = {
//   required: [{
//     required: true,
//     message: '该值不能为空',
//     trigger: 'blur'
//   }, {
//     required: true,
//     message: '该值不能为空',
//     trigger: 'change'
//   }],
//   requiredblur: [{
//     required: true,
//     message: '该值不能为空',
//     trigger: 'blur'
//   }, ],
//   requiredChange: [{
//     required: true,
//     message: '该值不能为空',
//     trigger: 'change'
//   }],
//   email: [{
//       required: true,
//       message: '该值不能为空',
//       trigger: 'blur'
//     },
//     {
//       type: "email",
//       message: '邮箱格式错误',
//       trigger: 'blur'
//     }
//   ],
//   number: [{
//     type: "number",
//     message: '输入数据类型错误，请输入数字！',
//     trigger: 'blur'
//   }],
//   numberRequired: [{
//       required: true,
//       message: '该值不能为空',
//       trigger: 'blur'
//     },
//     {
//       type: "number",
//       message: '输入数据类型错误，请输入数字！',
//       trigger: 'blur'
//     }
//   ],
//   doubleRequired: [{
//       required: true,
//       message: '该值不能为空',
//       trigger: 'blur'
//     },
//     {
//       pattern: /^[0-9,.]*$/,
//       message: '输入数据类型错误，请输入数字！',
//       trigger: 'blur'
//     }
//   ],
//   phoneNmuber: [{
//       required: true,
//       message: '该值不能为空',
//       trigger: 'blur'
//     },
//     {
//       pattern: /^1[0-9]{10}$/,
//       message: '输入正确的手机号码',
//       trigger: 'blur'
//     }
//   ],
//   password: [{
//       required: true,
//       message: '该值不能为空',
//       trigger: 'blur'
//     },
//     {
//       pattern: /.{6,16}/,
//       message: '密码要求6到32位，包含（字母、数字、符号 ）'
//     }
//   ],
//   password2: [{
//     pattern: /.{6,16}/,
//     message: '密码要求6到32位，包含（字母、数字、符号 ）'
//   }],
//   password4: [{
//     required: true,
//     message: '该值不能为空',
//     trigger: 'blur'
//   }, {

//     pattern: /^.{6,20}$/,
//     message: '密码要求6到32位任意字符'
//   }],
//   integer: [{
//     type: "integer",
//     message: '输入数据类型错误，请输入整数！',
//     trigger: 'blur'
//   }],
//   integerRequired: [{
//       required: true,
//       message: '该值不能为空',
//       trigger: 'blur'
//     },
//     {
//       type: "integer",
//       message: '输入数据类型错误，请输入整数！',
//       trigger: 'blur'
//     }
//   ],
//   email2: [{
//     type: "email",
//     message: '邮箱格式错误',
//     trigger: 'blur'
//   }],
//   phoneNmuber2: [{
//     pattern: /^1[0-9]{10}$/,
//     message: '输入正确的手机号码',
//     trigger: 'blur'
//   }],
//   phoneNmuber4: [{
//     pattern: /^1[0-9]{10}$/,
//     message: '输入正确的手机号码',
//     trigger: 'blur',
//     required: true

//   }],
//   float: [{
//     pattern: /^\d*\.{0,1}\d{0,9}$/,
//     message: '输入正确的数据',
//     trigger: 'blur'
//   }],
//   phoneNmuber3: [{
//     pattern: /^1[0-9]{10}$/,
//     message: '输入正确的手机号码',
//     trigger: 'blur'
//   }, {
//     required: false
//   }, ],
//   roleRequired: [{
//     type: "array",
//     message: '未选择角色',
//     required: true
//   }],
//   fileListRequired: [{
//     type: "array",
//     message: '未选择文件',
//     required: true
//   }],
//   positiveInteger: [{
//     pattern: /^([1-9]\d*|[0]{1,1})$/,
//     message: '输入数据类型错误，请输入整数！',
//     trigger: 'blur'
//   }],
//   lettersAndNumber: [{
//     pattern: /^[a-zA-Z\d]+$/,
//     message: '输入数据错误，只能包含字母和数字！',
//     trigger: 'blur'
//   }],
//   regionNumber: [{
//     pattern: /^.{0,6}$/,
//     message: '输入数据不能超过6位!',
//     trigger: "blur"
//   }],

//   regionNumber4: [{
//     pattern: /^.{0,4}$/,
//     message: '输入数据不能超过4位!',
//     trigger: "blur"
//   }],
//   postalCode: [{
//     pattern: /^[0-9]{6}$/,
//     message: '邮编格式错误',
//     trigger: "blur"
//   }],
//   fixedNumber: [{
//     pattern: /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$|(0\d{10})$/,
//     message: '固话号码格式错误',
//     trigger: "blur"
//   }],
//   identityCardId: [{
//     pattern: /^(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx])|([1−9]\d5\d2((0[1−9])|(10|11|12))(([0−2][1−9])|10|20|30|31)\d2[0−9Xx])/,
//     message: '身份证号格式错误',
//     trigger: "blur"
//   }],
//   integerRequiredNotNull: [{
//       required: true,
//       message: '该值不能为空'
//     },
//     {
//       pattern: /^[1-9][0-9]{0,10}$/,
//       message: '输入数据类型错误，请输入整数且大于0！'
//     },
//     {
//       type: "number",
//       message: '输入数据类型错误，请输入整数！'
//     },
//   ],
//   arrayRequired: [{
//     type: "array",
//     message: '该值不能为空',
//     required: true
//   }],
//   allNumber: [{
//       pattern: /^(\-|\+)?\d+(\.\d+)?$/,
//       message: '输入数据不是数字类型!',
//       trigger: "blur"
//     },
//     {
//       required: true,
//       message: '该值不能为空',
//       trigger: 'blur'
//     },
//   ],
//   numberNoRequired: [{
//     pattern: /^(\-|\+)?\d+(\.\d+)?$/,
//     message: '输入数据不是数字类型!',
//     trigger: "blur"
//   }, ],
//   moneyRequired: [{
//       required: true,
//       message: '该值不能为空',
//       trigger: 'blur'
//     },
//     {
//       // pattern: /^[1-9]{1}\d*(.\d{1,2})?$|^0.\d{1,2}$/,
//       pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
//       message: '请输入合法的金额数字，保留两位小数!',
//       trigger: "blur"
//     },

//   ],
//   chinese: [{
//       required: true,
//       message: '该值不能为空',
//       trigger: 'blur'
//     },
//     {
//       pattern: /^[^\u4e00-\u9fa5]+$/,
//       message: '不允许输入中文',
//       trigger: 'blur'
//     },
//     {
//       pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
//       message: '不允许输入空格等特殊符号',
//       trigger: 'blur'
//     },
//     {
//       pattern: /[0-9a-zA-Z]{1,6}/,
//       message: '只可以输入数字和字母',
//       trigger: 'blur'
//     },
//   ],
//   money: [{
//     // pattern: /^[1-9]{1}\d*(.\d{1,2})?$|^0.\d{1,2}$/,
//     pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
//     message: '请输入合法的金额数字，保留两位小数!',
//     trigger: "blur"
//   }, ],

// };
export default formRules;